import { lazyLoad } from 'utils/loadable';

export const BasicSEOSettings = lazyLoad(
  () => import('./index'),
  module => module.BasicSEOSettings,
);
